import { Link } from "react-router-dom";
import { ArrowRight } from "./Icons";

const resolveImage = (path) => {
  if (!path) return '';
  if (path.startsWith('/asset/')) {
    try {
      return require(`../asset/${path.replace('/asset/', '')}`);
    } catch (e) {
      return path;
    }
  }
  return path;
};

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

export default function BlogCard({ blog }) {
  return (
    <div className="blog-card">
      <div className="blog-card-image">
        <img
  src={resolveImage(blog.thumbnail)}
  alt={blog.title}
  loading="lazy"
  width="400"
  height="250"
/>
        <span className="blog-card-tag">{blog.category}</span>
      </div>
      <div className="blog-card-body">
        <div className="blog-card-meta">
          <span className="blog-date">{formatDate(blog.date)}</span>
        </div>
        <h3 className="blog-card-title">{blog.title}</h3>
        <p className="blog-card-excerpt">{blog.excerpt}</p>
        <Link
          to={`/blogs/${blog.slug}`}
          className="blog-card-link"
          aria-label={`Read full article: ${blog.title}`}
        >
          Read Article <ArrowRight />
        </Link>
      </div>
    </div>
  );
}